import { Button, ButtonGroup, Dialog, DialogBody, Tooltip } from '@blueprintjs/core';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Document, Page, pdfjs } from 'react-pdf';
import documentosService from '../../services/documentos.service.js';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
).toString();


export default function DocumentViewer(props) {
    const { name, url, icon, allowLoad, ext } = props;
    const [modal, setModal] = useState(false)
    const { t } = useTranslation();

    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [urlBlob, setUrl] = useState(null);
    const [selectedDoc, setDoc] = useState(null);

    const onLoadPdf = (file) => {
        if (allowLoad) {
            documentosService.load(file)
                .then(response => {
                    const contentDisposition = response.headers['content-disposition'];
                    const fileName = contentDisposition.split(';')[1].split('=')[1].replaceAll('"', '');
                    const type = fileName.split('.').pop();
                    // const mimeType = `application/${type}`;
                    const data = response.data;
                    const myBlob = new Blob([data]);

                    const blobUrl = window.URL.createObjectURL(myBlob);
                    setUrl(blobUrl);
                    setModal(true);
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const PDF_VIEWER = () => {
        return <div>
            <h5>{t('actions.page')} {t('actions.page')} {pageNumber} {t('actions.of')} {numPages}</h5>
            <ButtonGroup>
                <Tooltip content={t('actions.prev')} placement="top">
                    <Button icon="chevron-left" intent='primary' disabled={pageNumber === 1} onClick={() => {
                        setPageNumber(pageNumber - 1)
                    }} />
                </Tooltip>
                <Tooltip content={t('actions.next')} placement="top">
                    <Button icon="chevron-right" intent='primary' disabled={pageNumber === numPages} onClick={() => {
                        setPageNumber(pageNumber + 1)
                    }} />
                </Tooltip>
            </ButtonGroup>

            <Document file={urlBlob} onLoadSuccess={onDocumentLoadSuccess}>
                <Page pageNumber={pageNumber} />
            </Document>

        </div>
    }

    const IMG_VIEWER = () => {
        return <div>
            <img src={urlBlob} alt='...' />
        </div>
    }



    const MODAL = () => <Dialog
        title={t('actions.see_doc').replace("%VAR%", selectedDoc)}
        icon={icon || "document"}
        isOpen={modal} onClose={() => setModal(false)}
        className='modal-app-cli'>
        <DialogBody useOverflowScrollContainer={true} >

            {urlBlob && ext === "PDF" ? PDF_VIEWER() : null}
            {urlBlob && (ext === "PNG" || ext === "JPEG" || ext === "JPG") ? IMG_VIEWER(): null}
        </DialogBody>
    </Dialog>

    return (<>
        {allowLoad ? <>
            {MODAL()}
            <Tooltip content={t('actions.see_more')} placement="top">
                <Button icon={icon || "eye-open"} intent='primary' onClick={() => {
                    setUrl(null)
                    setDoc(name)
                    onLoadPdf(url)
                }} />
            </Tooltip>
        </> : null}
    </>
    );
}
